import { useAuthStore } from "@kaplan-labs/up-auth-api-client";
import { useEffect, useRef } from "react";

import { ProfileType, useProfile, useTheme } from "@up/data";
import { Animation, LoadingError, LoadingModal, ProfileSelect } from "@up/ui";

export const Profiles = function () {
  const auth = useAuthStore();
  const profile = useProfile();
  const theme = useTheme();

  /*
    Effects
    ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
  */

  const initialized = useRef(false);
  useEffect(
    function autoSelect() {
      const go = async function () {
        if (profile.isLoading || profile.didError || !profile.data) {
          return;
        }
        if (
          profile.data.type === ProfileType.Student ||
          !("type" in profile.data)
        ) {
          initialized.current = true;
        }
        if (profile.data.relatedStudents?.length === 1) {
          initialized.current = true;
        }
      };

      if (initialized.current) {
        return;
      } else {
        go();
      }
    },
    [auth, initialized, profile],
  );

  /*
    User Interface
    ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
  */

  if (profile.isLoading) {
    return <LoadingModal />;
  }

  if (profile.didError) {
    return (
      <LoadingError
        error="Sorry, we could not load your profile"
        errorCode={profile.errorCode}
      />
    );
  }

  if (profile.data) {
    return (
      <Animation type="splash-in">
        <ProfileSelect
          heading={
            <>
              <h2 className={theme.heading2Class}>Select a student</h2>
              <p className="mb-6">
                Who is the student you are applying for today?
              </p>
            </>
          }
          contacts={profile.data?.relatedStudents ?? []}
          select={(e, c) => {
            console.log("what should I do here?", e, c);
          }}
        />
      </Animation>
    );
  }

  return <div data-testid="scholarship-profile-should-not-be-here" />;
};
